import React, { useCallback } from 'react';

import SuccessOverlay from '../../Shared/components/SuccessOverlay';
import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';

export const Success: React.FC = () => {
  const complete = useCallback(() => {
    locationAssign(urlBuilder.appHome.absolute());
  }, []);

  return <SuccessOverlay message="Nice job, you’ve confirmed your account!" onCompletion={complete} />;
};
